import { mutate } from 'network/queue';
import { API_URL } from 'appenv';
import { gql } from '@apollo/client';
import waitForDeferredResult from './resultDeferrer';

const CommonJob = gql`
  fragment CommonJob on Job {
    id
    status
  }
`;

const CommonRegisterEventxtraAttendeeJob = gql`
  ${CommonJob}
  fragment CommonRegisterEventxtraAttendeeJob on RegisterEventxtraAttendeeJob {
    ...CommonJob
    result {
      accessToken
      attendee {
        name
        firstName
        lastName
        uuid
        email
        company
        title
        tickets {
          nodes {
            id
            name
          }
        }
        rongcloudToken
        customAttendeeFields
        rongcloudUserId
        rongcloudUser {
          id
          vexpoChatTag
          vexpoChatUserDescription
        }
      }
    }
  }
`;

const queryJobStatus = gql`
  ${CommonRegisterEventxtraAttendeeJob}
  query registerEventxtraAttendeeJobStatus($jobId: ID!) {
    job: node(id: $jobId) {
      ...CommonRegisterEventxtraAttendeeJob
    }
  }
`;

const registerEventxtraAttendeeMutation = gql`
  mutation registerEventxtraAttendeeAsync($input: RegisterEventxtraAttendeeAsyncInput!) {
    request: registerEventxtraAttendeeAsync(input: $input) {
      success
      errors {
        message
      }
      job {
        id
        status
        result {
          attendee {
            name
          }
        }
      }
    }
  }
`;

async function registerEventxtraAttendee(eventId: string, attendeeUniqueToken: string) {
  return mutate({
    mutation: registerEventxtraAttendeeMutation,
    variables: {
      input: {
        eventId,
        uniqueToken: attendeeUniqueToken,
      },
    },
  })
    .then((response) => waitForDeferredResult(response, queryJobStatus));
}

export default registerEventxtraAttendee;
